import React from "react";
import { Navigate } from "react-router-dom";
function ProtectedRoute({ success, children }) {
	if (!success) {
		return <Navigate to="/home" replace />;
	}
	return children;
}
export default ProtectedRoute;
